import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; 
import './Mainservices.css'; 
import ContactForm from '../ContactForm';

function Branding() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  return (
    <>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>

      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">how people view your business.</h1>
            <p className="banner-description">
              We develop a comprehensive strategy for both internal and external branding, meticulously analyzing every detail to deliver the performance our clients require. With our expertise, we ensure every element is optimized for success.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
        </div>
      </section>

      <div className='img-background'>
        <img
          className="img"
          id='banner1-video'
          src="/img/Main Services Thumbnail.png"  // Correct the path if the image is in the public folder
          autoPlay
          muted
          loop
          playsInline
          onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
          alt="img"
        />
      </div>

      {/* Brand Identity Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>External Brand Identity</strong></h2>
            <p>
              Your brand identity is the foundation of your business. We work with you to develop a unique identity that communicates your values and vision clearly to your audience.
            </p>
            <ul>
              <li><strong>Logo Design:</strong> Crafting memorable logos that stand out.</li>
              <li><strong>Color Palettes:</strong> Choosing the right colors to evoke emotion.</li>
              <li><strong>Typography:</strong> Custom fonts that enhance brand personality.</li>
              <li><strong>Brand Guidelines:</strong> Creating a consistent look and feel.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m1.1.png" alt="Brand Identity" />
          </div>
        </div>

        {/* Brand Strategy Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Internal Brand Strategy</strong></h2>
            <p>
              We help you develop a strategic brand plan that aligns with your business goals and market positioning. Our approach combines creative and analytical thinking to ensure long-term success.
            </p>
            <ul>
              <li><strong>Market Research:</strong> Understanding your audience and competition.</li>
              <li><strong>Positioning:</strong> Defining your place in the market.</li>
              <li><strong>Messaging:</strong> Crafting the right message for your audience.</li>
              <li><strong>Brand Story:</strong> Building a narrative that connects with consumers.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m1.2.png" alt="Brand Strategy" />
          </div>
        </div>

        {/* Brand Experience Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Brand Experience</strong></h2>
            <p>
              Creating a cohesive brand experience across all touchpoints. From digital to physical, we ensure that every interaction reinforces your brand's message.
            </p>
            <ul>
              <li><strong>Website & UX Design:</strong> Crafting intuitive and visually compelling experiences.</li>
              <li><strong>Packaging Design:</strong> Designing packaging that represents your brand.</li>
              <li><strong>Marketing Collateral:</strong> Creating consistent marketing materials.</li>
              <li><strong>Brand Activations:</strong> Engaging experiences that bring your brand to life.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m1.3.png" alt="Brand Experience" />
          </div>
        </div>

        {/* Brand Success Stories Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Brand Success Stories</strong></h2>
            <p>
              Discover how our branding solutions have helped businesses grow and succeed in their markets.
            </p>
            <a href='/blog' className="cta-button">Read Our Brand Case Studies</a>
          </div>
          <div className="about-image">
            <img src="/img/m1.4.png" alt="Brand Success Stories" />
          </div>
        </div>
      </section>

      {/* Contact Form (Initially Hidden, controlled by `contactFormRef`) */}
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default Branding;
